// import * as AuthActions from '../actions/auth.actions';
import { Action, State } from '@ngrx/store';
import { Auth } from '../../model/auth.model';
import { AuthActionsUnion, AuthActionTypes } from '../actions/auth.actions';

export interface AuthData {
  // is a user authenticated?
  isAuthenticated: boolean,
  access_token: string,
  refresh_token: string,
  xBundleRecurring: string,
  // error message
  hasError: boolean,
  message: string | null,
  loading: boolean,
}

export const initialState: AuthData = {
  isAuthenticated: false,
  access_token: null,
  refresh_token: null,
  xBundleRecurring: null,
  loading: false,
  hasError: false,
  message: null
};

export function reducer (state = initialState, action: AuthActionsUnion): AuthData {
  switch (action.type) {
    case AuthActionTypes.Login: {
        return { ...state, loading: true };
    }
    case AuthActionTypes.LoginSuccess: {
        return {
        ...state,
            access_token: action.payload.access_token,
            xBundleRecurring: action.payload.xBundleRecurring,
            isAuthenticated: true,
            loading: false,
        };
    }
    case AuthActionTypes.LoginFailure:{
        return {
            ...state,
            isAuthenticated: false,
            access_token: null,
            refresh_token: null,
            xBundleRecurring: null,
            loading: false,
            message: action.message,
            hasError: true
        }
    }
    case AuthActionTypes.Logout:{
        return {
            ...state,
            isAuthenticated: false,
            access_token: null,
            refresh_token: null,
            loading: false,
        }
    }
    case AuthActionTypes.ClearMessage:{
        return {
            ...state,
            hasError: false,
            message: null
        }
    }
    case AuthActionTypes.UpdateBundleRecurring:{
        return {
            ...state,
            xBundleRecurring: action.xBundleRecurring,
            loading: false,
        }
    }
    default: {
      return state;
    }
  }
}

// export function reducer(state: AuthData | undefined, action: Action) {
//   return authReducer(state, action);
// }